import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-project_phone",
  "use": "icon-project_phone-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"icon-project_phone\"><g stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"2\"><path d=\"M4.1 24.485c2.734 2.734 9.066.834 14.143-4.242 5.076-5.077 6.976-11.409 4.242-14.142\" /><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M4.071 24.456L.565 20.95l4.83-4.83 4.243 4.242 8.713-8.713-4.242-4.243 4.84-4.841 3.507 3.506\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol